export const appearance = {
  title: "Appearance",
  subtitle: "Choose how Webkurator should look for you.",
  modeLabel: "Theme mode",
  modeLight: "Light",
  modeLightLabel: "Always use your light palette.",
  modeDark: "Dark",
  modeDarkLabel: "Always use your dark palette.",
  modeSystem: "System",
  modeSystemLabel: "Follow your system preference.",
  modeSun: "Sunrise / Sunset",
  modeSunLabel: "Switch automatically based on local sunrise and sunset.",
  modeSchedule: "Custom times",
  modeScheduleLabel: "Switch at your chosen light/dark times.",
  activeLabel: "Active",
  lightFocusLabel: "Light focus",
  darkFocusLabel: "Dark focus",
  sunriseTitle: "Sunrise/Sunset today",
  sunriseDescription:
    "Sunrise: {sunrise}, Sunset: {sunset}. It is currently {state}. Next change at {nextSwitch}.",
  sunriseStateDay: "daytime",
  sunriseStateNight: "nighttime",
  lightThemes: "Light themes",
  darkThemes: "Dark themes",
  customTitle: "Custom theme",
  customDescription: "Design your own light and dark pair.",
  customBuilder: "Custom palette",
  lightMode: "Light",
  darkMode: "Dark",
  colorBackground: "Background",
  colorSurface: "Surface",
  colorForeground: "Foreground",
  colorPrimary: "Primary",
  colorAccent: "Accent",
  radixPaletteHint:
    "Use a Radix UI palette as a starting point and fine-tune individual swatches.",
  scheduleLight: "Light starts at",
  scheduleDark: "Dark starts at",
  scheduleHour: "Hour",
  scheduleMinute: "Minute",
  presets: {
    classic: {
      name: "Classic",
    },
    sunrise: {
      name: "Sunrise",
    },
    evergreen: {
      name: "Evergreen",
    },
    "violet-bloom": {
      name: "Violet Bloom",
    },
    seaside: {
      name: "Seaside",
    },
    midnight: {
      name: "Midnight",
    },
    ember: {
      name: "Ember",
    },
    "forest-night": {
      name: "Forest Night",
    },
    afterglow: {
      name: "Afterglow",
    },
    neon: {
      name: "Neon",
    },
  },
  radixSwatches: {
    blue: "Blue",
    teal: "Teal",
    violet: "Violet",
    amber: "Amber",
    grass: "Grass",
    cyan: "Cyan",
    mint: "Mint",
    sand: "Sand",
  },
};
